import CRUDFormComponent from '../../components/CRUDFormComponent'

const DiseasesForm = () => {
  const fields = [{ key: 'name', label: 'Nombre', type: 'string' }]

  return (
    <>
      <CRUDFormComponent
        entityName={{ singular: 'Enfermedad' }}
        fields={fields}
        entityUrl="/diseases"
      />
    </>
  )
}

export default DiseasesForm
